import { Form } from "antd"


const FormItem = ({ name, children, rules, ...rest }) => {
  return (
    <Form.Item
        style={{ marginBottom: 0 }}
        name={name}
        rules={rules}
        {...rest}
    >
      {children}
    </Form.Item>
  )
}

export default FormItem